import React from "react";
import { Container } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { PieChart } from 'react-minimal-pie-chart';
import { Chart } from "react-google-charts";

import Heading from '../../Components/sectionHeading'
import tokenomics from '../../images/tokenomics.png'
import tokenomicsimg from '../../images/tokenomicsimg.png'


const Tokenomics = () => {
  return (
    <div id="tokenomics" className="">
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="py-5"
        >
          <Grid
              xs={12}
              className="position-relative"
          >
            <Heading 
                title="Tokenomics"
                // subtitle="Tokenomics"
            />
             <img src={tokenomicsimg} className="img-fluid" 
             style={{
               width: '12%',
              marginLeft: 'auto',
              marginRight: '78px',
              display: 'block',
              position: 'absolute',
              right: 10,
              zIndex: 3
              }} />
          </Grid>
          <Grid
              xs={12}
              sm={8}
              className="text-center FTM---Piechart"
          >
            <Chart
                height={'300px'}
                chartType="PieChart"
                loader={<div>Loading Chart</div>}
                data={[
                  ['Task', 'Hours per Day'],
                  ['Marketing', 2],
                  ['Development', 2],
                  ['Competitions', 2],
                  ['CEX MM', 8],
                  ['Liquidity', 40],
                  ['Tokens for LP providers', 46],
                ]}
                options={{
                  // title: 'My Daily Activities',
                  // Just add this option
                  is3D: true,
                }}
                rootProps={{ 'data-testid': '2' }}
              />

                        
            {/* <img src={tokenomics} className="img-fluid" style={{width: '70%'}} /> */}
            {/* <h5 className="py-5" style={{color:'#ffffff'}}>Transactionomics</h5> */}
            <h5 className="pt-2" style={{color:'#ffffff'}}>10M Total Supply</h5>
            <h5 className="pt-2" style={{color:'#ffffff'}}>2% Marketing</h5>
            <h5 className="pt-2" style={{color:'#ffffff'}}>2% Development</h5>
            <h5 className="pt-2" style={{color:'#ffffff'}}>2% Competitions</h5>
            <h5 className="pt-2" style={{color:'#ffffff'}}>8% CEX MM</h5>
            <h5 className="pt-2" style={{color:'#ffffff'}}>40% Liquidity</h5>
            <h5 className="pt-2 pb-5" style={{color:'#ffffff'}}>46% Tokens for LP providers</h5>
            {/* <h5 className="pt-2 pb-5" style={{color:'#ffffff'}}>)</h5> */}

          </Grid>
         
        </Grid>
      </Container>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="py-5"
        >
          <Grid
              xs={12}
              className="position-relative"
          >
            <Heading 
                title="Transactionomics
                "
                // subtitle="Tokenomics"
            />
             {/* <img src={tokenomicsimg} className="img-fluid" 
             style={{
               width: '12%',
              marginLeft: 'auto',
              marginRight: '78px',
              display: 'block',
              position: 'absolute',
              right: 10,
              zIndex: 3
              }} /> */}
          </Grid>
          <Grid
              xs={12}
              sm={8}
              className="text-center FTM---Piechart"
          >
            {/* <Chart
                height={'300px'}
                chartType="PieChart"
                loader={<div>Loading Chart</div>}
                data={[
                  ['Task', 'Hours per Day'],
                  ['Marketing', 2],
                  ['Development', 2],
                  ['Competitions', 2],
                  ['CEX MM', 8],
                  ['Liquidity', 40],
                  ['Tokens for LP providers', 46],
                ]}
                options={{
                  // title: 'My Daily Activities',
                  // Just add this option
                  is3D: true,
                }}
                rootProps={{ 'data-testid': '2' }}
              /> */}

                        
            {/* <img src={tokenomics} className="img-fluid" style={{width: '70%'}} /> */}
            {/* <h5 className="py-5" style={{color:'#ffffff'}}>Transactionomics</h5> */}
            {/* <h5 className="pt-2" style={{color:'#ffffff'}}>Token Distribution</h5> */}
            <h5 className="pt-2" style={{color:'#ffffff'}}>6% FANTOM rewards</h5>
            <h5 className="pt-2" style={{color:'#ffffff'}}>2% Liquidity generation</h5>
            <h5 className="pt-2" style={{color:'#ffffff'}}>2% Maintenance wallet</h5>
            <h5 className="pt-2" style={{color:'#ffffff'}}>2% Token buyback & burn</h5>
            {/* <h5 className="pt-2" style={{color:'#ffffff'}}>40% Liquidity</h5>
            <h5 className="pt-2 pb-5" style={{color:'#ffffff'}}>46% Tokens for LP providers</h5> */}
            <h5 className="pt-2 pb-5" style={{color:'#ffffff'}}>(All rewards are automatically distributed bi-daily)</h5>

          </Grid>
         
        </Grid>
      </Container>
    </div>
  );
}

export default Tokenomics;
